import { WhichWeightAPI } from 'WhichWeightAPI';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrganizationAthletes } from 'redux/slices/organization';

export const useGetAthletes = () => {
    
    const dispatch = useDispatch();

    const userId = useSelector(state => state.user.id);
    const organizationId = useSelector(state => state.user.organizationId);
    const cachedAthletes = useSelector(state => state.organization.athletes);

    const [athletes, setAthletes] = useState(cachedAthletes);

    const FetchAthletesFromBackend = async () => {
        const jsonBody = {
            requestingUserId: userId,
            organizationId: organizationId
        }

        // console.log(jsonBody);

        const result = await WhichWeightAPI("REPORTING", "GET", "/organization_trainees", jsonBody);

        // console.log(result.data.data);

        dispatch(setOrganizationAthletes(result.data.data));

        setAthletes(result.data.data);
    }

    useEffect(() => {
        if (userId === null) return;
        if (organizationId === null) return;

        if (cachedAthletes === null) {
            FetchAthletesFromBackend();
        } 
        
        // Make sure any changes to the redux store directly get updated
        if (cachedAthletes !== null) {
            setAthletes(cachedAthletes);
        }
    }, [cachedAthletes, dispatch]);

    return athletes;
};